var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bg",style:({ 'background-image': 'url(' + _vm.bg + ')' })},[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"sub-title",domProps:{"innerHTML":_vm._s(_vm.subTitle)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }